<template>
  <ion-page>
    <master-layout pageTitle="درآمد فروش ضایعات">
      <ion-card>
        <ion-card-content>
          <DataTable auto-reload="1" :headers="headers" :route="route"></DataTable>
          <div class="between">
            <div></div>
            <div>
              جمع درآمد :
              <money :number="wastage_total"></money>
            </div>
          </div>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";
import {mapActions} from "vuex";
import Money from '/src/components/Money'

export default {
  data()
  {
    return {
      id: null,
      wastage_total : 0,
      route:'wastageProfit/ListAjax',
      headers: [
        'شماره فاکتور',
        'تاریخ',
        'جمع',
      ]
    };
  },
  async created()
  {
    this.id = this.$route.params.id;
  },
  methods: {
    ...mapActions("app", {
      getIncomeReportItems: 'getIncomeReportItems',
    }),
  },
  async mounted()
  {
    const check = await this.getIncomeReportItems()
    if (check && check.ok)
    {
      this.wastage_total = check.wastage_total;
    }
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage,Money
  },
  watch: {
    // $route()
    // {
    //   if (this.$route.fullPath.indexOf('wastageProfit/ListAjax') >= 0)
    //   {
    //     this.route = 'wastageProfit/ListAjax?t='+(new Date().getTime())
    //   }
    // }
  }
};
</script>

<style scoped>
.between
{
  display: flex;
  justify-content: space-between;
}
</style>